module.exports = __webpack_public_path__ + "img/screen1900_neg.78f4a48a.svg";